module.exports = __webpack_public_path__ + "img/sld_mfm_spare_2_t1_b1_dark.02bb8508.svg";